type PlaybackReceiver = {
  jitterBufferTarget?: number | null;
  playoutDelayHint?: number | null;
};

// The browser owns the decoder/network queues. These hints request the desired
// extra playout delay; zero must stay zero for low-latency playback.
export const applyReceiverPlaybackBuffer = (
  receiver: PlaybackReceiver,
  requestedBufferMs: number,
): void => {
  const bufferMs = Number.isFinite(requestedBufferMs)
    ? Math.max(0, requestedBufferMs)
    : 0;

  // Treat the two APIs independently: a rejected or obsolete hint must not
  // prevent the browser from receiving the supported one.
  if ("jitterBufferTarget" in receiver) {
    try {
      receiver.jitterBufferTarget = bufferMs;
    } catch {
      // Some engines expose the property but reject particular target values.
    }
  }
  if ("playoutDelayHint" in receiver) {
    try {
      receiver.playoutDelayHint = bufferMs / 1000;
    } catch {
      // Experimental API; jitterBufferTarget may still have succeeded.
    }
  }
};
